<div class="refund-modal">
  <h2 mat-dialog-title>Select Refund Option</h2>

  <mat-dialog-content>
    <div class="refund-options">
      <button mat-raised-button [color]="selectedOption === 'full' ? 'primary' : ''" (click)="selectOption('full')"
        class="option-button">
        Pay back full amount ({{ data.maxAmount }} SEK)
      </button>

      <button mat-raised-button [color]="selectedOption === 'partial' ? 'primary' : ''"
        (click)="selectOption('partial')" class="option-button">
        Pay back partial amount
      </button>

      @if (selectedOption === 'partial') {
        <mat-form-field appearance="fill" class="amount-input">
          <mat-label>Amount (SEK)</mat-label>
          <input matInput type="number" [formControl]="partialAmountControl" placeholder="Enter amount" step="0.01">
          <mat-hint>Amount cannot exceed {{ data.maxAmount }} SEK</mat-hint>
          @if (partialAmountControl.hasError('required')) {
            <mat-error>Amount is required</mat-error>
          }
          @if (partialAmountControl.hasError('min')) {
            <mat-error>Amount must be greater than 0</mat-error>
          }
          @if (partialAmountControl.hasError('max')) {
            <mat-error>Amount cannot exceed {{ data.maxAmount }}
            SEK</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!isValid">Confirm</button>
  </mat-dialog-actions>
</div>